<template>
  <div id="app" v-cloak>
    <Header />
    <PromoSection />
    <HowTo />
    <Collections />
    <Participants />
  </div>
</template>

<script>
import Header from "./components/Header";
import PromoSection from "./components/PromoSection";
import HowTo from "./components/HowTo";
import Collections from "./components/Collections";
import Participants from "./components/Participants";
import AnalyticsEvents from "@/data/analyticsEvents";
import data from "@/data/data"

export default {
  name: "app",
  components: {
    Header,
    HowTo,
    Collections,
    Participants,
    PromoSection,
  },
  mounted() {
    this.initializeAnalytics();

    // const formatText = i =>decodeURIComponent(i).replace('&laquo;','').replace('&raquo;', '');

    // console.log(JSON.stringify(data.items.map(item => ({
    //   name: formatText(item.name),
    //   shortname: formatText(item.shortname),
    //   city: formatText(item.city),
    //   address: formatText(item.address),
    //   coordinates: [item.coord_x, item.coord_y]
    // }))))
  },
  methods: {
    initializeAnalytics() {
      const events = AnalyticsEvents;

      window.addEventListener("click", (event) => {
        let target;

        event.target.hasAttribute("data-user-action")
          ? (target = event.target)
          : (target = event.target.closest("[data-user-action]"));

        if (!target) {
          return;
        }

        for (const [key, value] of Object.entries(events)) {
          if (key === target.dataset.userAction) {
            if (value.label === "PageUrl") {
              value.label = target.href;
            }

            window.dataLayer.push({
              event: value.event,
              eventAction: value.action,
              eventCategory: value.category,
              eventLabel: value.label,
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="css">
body {
  background: url("assets/images/patern.jpg");
  background-size: 960px;
  min-width: 320px;
  font-family: "Rubik", system-ui, -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
}

button {
  outline: 0;
}

.text-thin {
  font-family: "Rubik";
}

.text-light {
  font-family: "Rubik";
}

.text-regular {
  font-family: "Rubik";
}

.text-bold {
  font-family: "Rubik";
  font-weight: bold;
}

.text-extra-bold {
  font-family: "Rubik";
}

.text-karusel-regular {
  font-family: "Rubik";
}

.text-karusel-small {
  font-family: "Rubik";
}

[v-cloak] {
  @apply hidden;
}

#app {
  @apply overflow-x-hidden;
}

.v-lazy-image {
  filter: blur(0.5rem);
  transition: filter 0.5s;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
</style>
